import { gql } from '@apollo/client';

export const GROUPS_LIST = gql`
  query groups {
    groups {
      allowedSearch
      allowedDashboards
      displayName
      id
      permission
      totalMembers
    }
  }
`;

export const EDIT_GROUP_PERMISSIONS = gql`
  mutation editGroupPermissions(
    $groupId: String!
    $permission: AccessType!
    $allowedSearch: String
    $allowedDashboards: [String]
  ) {
    editGroupPermissions(
      groupId: $groupId
      permission: $permission
      allowedSearch: $allowedSearch
      allowedDashboards: $allowedDashboards
    ) {
      id
      displayName
      permission
      totalMembers
    }
  }
`;
